module.exports = __webpack_public_path__ + "img/btn_sound_off@2x.c242d2a7.png";